import {
  ANNUAL_REPORT_GET_PROGRAM_ACTIVITIES,
  ANNUAL_REPORT_PROGRAM_ACTIVITIES
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

export const getProgramActivities =
  (AssociationNumber, BranchNumber, year) => (dispatch, getState) =>
    asyncRequest({
      url: ANNUAL_REPORT_GET_PROGRAM_ACTIVITIES(
        AssociationNumber,
        BranchNumber,
        year
      ),
      successAction: data => ({
        type: types.PROGRAM_ACTIVITY_GET_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.PROGRAM_ACTIVITY_GET_FAILURE,
        payload: error
      }),
      dispatch
    });
export const programActivities = bodyObject => (dispatch, getState) =>
  asyncRequest({
    url: ANNUAL_REPORT_PROGRAM_ACTIVITIES(),
    method: 'POST',
    data: bodyObject,
    successAction: data => ({
      type: types.PROGRAM_ACTIVITY_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.PROGRAM_ACTIVITY_FAILURE,
      payload: error
    }),
    dispatch
  });
